module.exports = __webpack_public_path__ + "img/142.3b9d2ba2.gif";